import React, { useEffect, useState } from "react"
import SwiperCore, { Mousewheel, Scrollbar, Controller, Thumbs } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import SimpleBar from "simplebar-react"
import "simplebar/dist/simplebar.min.css"
import Social from "../../atoms/Social"

import "./styles.scss"

const getRandomColor = () => {
  const items = [
    '#FFEBF7',
    '#FFEAEA',
    '#FFEDE0',
    '#FFF6D2',
    '#EBF4E4',
    '#DFF2F9',
    '#F3EDFC',
  ]

  return items[Math.floor(Math.random()*items.length)];
}


const Animoji = ({position, animoji}) => {

  const {x, y} = position;

  return(
    <div
      className={`animoji-hld ${animoji ? "animoji-hld--visible" : ""}`}
      style={{left: x, top: y, background: animoji?.color}}
    >
    <div
      className="animoji"
      style={{background: `url("${animoji?.frames}")`}}
    ></div>
    </div>
  )
}


const Member = ({member, setAnimoji}) => {

  const linkedin = member.memberSocials?.memberLinkedin ?
    <Social
      type="linkedin"
      to={member.memberSocials.memberLinkedin}
    />
  : null

  const behance = member.memberSocials?.memberBehance ?
    <Social
      type="behance"
      to={member.memberSocials.memberBehance}
    />
  : null

  const dribble = member.memberSocials?.memberDribbble ?
    <Social
      type="dribble"
      to={member.memberSocials.memberDribbble}
    />
  : null

  return(
    <div
      className="member"
      onMouseEnter={ () => {
        if (member.animoji?.frames) {
          setAnimoji({
            frames: member.animoji.frames.childImageSharp.original.src,
            color: getRandomColor(),
          })
        } else {
          setAnimoji(null)
        }
      }}
      onMouseLeave={ () => setAnimoji(null) }
    >
      <p className="member__name">{member.name}</p>
      <p className="member__title">{member.jobTitle}</p>

      {member.memberSocials &&
        <div className="member__socials">
          {linkedin}
          {behance}
          {dribble}
        </div>
      }
    </div>
  )

}


const Team = ({ name, members, setAnimoji }) => {

  return(
    <div className="team">
      <p className="team__name">{name}</p>
      <div className="team__members">

        {members?.map((member, i) => {
          return (
            <Member
              member={member}
              key={i}
              setAnimoji={setAnimoji}
            />
          )
        })}

      </div>
    </div>
  )
}



const useMove = () => {
  const [state, setState] = useState({x: -200, y: -200})

  const handleMouseMove = e => {
    e.persist()
    setState(state => ({...state, x: e.clientX, y: e.clientY}))
  }
  return {
    x: state.x,
    y: state.y,
    handleMouseMove,
  }
}

const TeamGallery = ({ members, teams }) => {

  const [isDesktop, setIsDesktop] = useState(true)
  const {x, y, handleMouseMove} = useMove();
  const [animoji, setAnimoji] = useState(null);

  function checkDevice() {
    if (window.innerWidth > 900) {
      setIsDesktop(true)
    } else {
      setIsDesktop(false)
    }
  }

  useEffect(() => {
    checkDevice()
  }, [])

  useEffect(() => {
    window.addEventListener("resize", checkDevice)
    return () => {
      window.removeEventListener("resize", checkDevice)
    }
  })

  return(

    <>
      <div
        className="teamsList"
        onMouseMove={handleMouseMove}
      >
        {teams?.map((team, i) => {
          const teamMembers = members.filter(m => m.teamMember?.Name == team.Name);
          if (!teamMembers.length) return;

          return (
            <Team
              key={i}
              name={team.Name}
              members={teamMembers}
              setAnimoji={(a) => setAnimoji(a)} />
          )
        })}
      </div>
      {isDesktop && (
        <Animoji
          position={{
            x: x + 30,
            y: y - 10
          }}
          animoji={animoji}
        />
      )}
    </>

  )
}

export default TeamGallery
